import { t } from "@lingui/macro";
import { Box, Container, useTheme } from "@mui/material";
import {
  MenuList,
  MenuListItemType,
  MenuListItemVariant,
  WfIconSportAirBold,
  WfIconSportBoltFill,
  WfIconSportHeartFill,
  WfIconSportSpeedFill,
} from "@WahooFitness/redesignr";
import { ReactRouterLinkWrapper } from "../MenuList/ReactRouterLinkWrapper";
import { GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";
import useHasElemntWithTymewear from "@/hooks/useHasElemntWithTymewear";

type MenuListItemTypeWithDataTestId = MenuListItemType & { "data-testid": string };

const ZonesIndex = () => {
  const { palette } = useTheme();
  const hasElemntWithTymewear = useHasElemntWithTymewear();
  const zoneOptions: MenuListItemTypeWithDataTestId[] = [
    {
      icon: <WfIconSportHeartFill sx={{ fill: palette.data.heartRate.main }} />,
      id: "heartRateZones",
      content: t`Heart rate zones`,
      variant: MenuListItemVariant.InternalLink,
      linkComponent: ReactRouterLinkWrapper,
      linkLocation: "/zones/heart-rate-zones",
      "data-testid": "settings.hrZones",
    },
    {
      icon: <WfIconSportBoltFill sx={{ fill: palette.data.power.main }} />,
      id: "powerZones",
      content: t`Power zones`,
      variant: MenuListItemVariant.InternalLink,
      linkComponent: ReactRouterLinkWrapper,
      linkLocation: "/zones/power-zones",
      "data-testid": "settings.powerZones",
    },
    {
      icon: <WfIconSportSpeedFill sx={{ fill: palette.data.speed.main }} />,
      id: "paceZones",
      content: t`Running pace zones`,
      variant: MenuListItemVariant.InternalLink,
      linkComponent: ReactRouterLinkWrapper,
      linkLocation: "/zones/pace-zones",
      "data-testid": "settings.paceZones",
    },
    {
      icon: <WfIconSportAirBold sx={{ fill: palette.zones.ventilationZones.zone1.main }} />,
      id: "ventilationZones",
      content: t`Ventilation zones`,
      variant: MenuListItemVariant.InternalLink,
      linkComponent: ReactRouterLinkWrapper,
      linkLocation: "/zones/ventilation-zones",
      "data-testid": "settings.ventilationZones",
      hidden: !hasElemntWithTymewear,
    },
  ];
  return (
    <>
      <GlobalHeader title={t`Zones`} />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <Box py={1}>
          <MenuList variant="elevation" listItems={zoneOptions} />
        </Box>
      </Container>
    </>
  );
};

export { ZonesIndex };
